import React from "react";
import "./Header.css";
/* ReactScroll */
import { Link } from "react-scroll";

/* React router */
import { NavLink } from "react-router-dom";

/* DarkMode */
import DarkMode from "../DarkMode/DarkMode";

/* Language */

const Header = () => {
  // Menu desplegable
  const menuDesplegable = () => {
    let navbar = document.querySelector(".navbar");
    navbar.classList.toggle("active");

    window.onscroll = () => {
      if (window.scrollY > 0) {
        document.querySelector(".site-header").classList.add("active");
      } else document.querySelector(".site-header").classList.remove("active");

      navbar.classList.remove("active");
    };
  };

  return (
    <header className="site-header">
      <div
        id="menu-btn"
        className="fas fa-bars"
        onClick={menuDesplegable}
      ></div>

      <NavLink className="logo" to="/">
        Zaid Rajab
      </NavLink>

      <nav className="navbar">
        <Link to="about-me" spy={true} offset={-150} href="#about-me">
          About
        </Link>
        <Link to="experience" spy={true} offset={-150} href="#experience">
          Experience
        </Link>
        <Link to="projects" spy={true} offset={-150} href="#projects">
          Projects
        </Link>
        <Link to="certificates" spy={true} offset={-150} href="#certificates">
          Certificates
        </Link>
        <Link to="contact" spy={true} offset={-150} href="#contact">
          Contact
        </Link>
      </nav>
      <div className="switch" id="switch">
        <DarkMode />
      </div>
    </header>
  );
};

export default React.memo(Header);
